import React from 'react';
import {Spin} from 'antd';
import {LoadingOutlined} from '@ant-design/icons';
import {colors} from '../theme';

const PageLoading: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
        gap: 16,
      }}
    >
      <Spin indicator={<LoadingOutlined style={{fontSize: 40, color: colors.primary}} spin />} />
      <span style={{fontSize: 14, color: colors.textSecondary, fontWeight: 500}}>Loading...</span>
    </div>
  );
};

export default PageLoading;
